import React from 'react'
import queryString from 'query-string'

import Editor from './editor/editor'
import Readonly from './readonly/readonly'
import { hosts } from '../actioncreators/hosts'

const { Component } = React

class App extends Component {
  render () {
    const parsed = queryString.parse(this.props.queryString)

    const editorMode = parsed.mode === 'edit-dialog' || this.props.host === hosts.STANDALONE
    const Component = editorMode ? Editor : Readonly
    if (editorMode) {
      document.body.style.background = 'radial-gradient(circle, rgba(103,107,130,1) 0%, rgba(55,54,54,1) 100%)'
    }
    return <div>
      <div>
        <Component />
      </div>
    </div>
  }
}

export default App
